// utils/colorUtils.js

const ICON_BACKGROUNDS = [
  { background: "#fef3c7", color: "#92400e" }, // amber
  { background: "#dbeafe", color: "#1e40af" }, // blue
  { background: "#dcfce7", color: "#166534" }, // green
  { background: "#fce7f3", color: "#9d174d" }, // pink
  { background: "#ede9fe", color: "#5b21b6" }, // purple
  { background: "#ffedd5", color: "#9a3412" }, // orange
  { background: "#e0f2fe", color: "#075985" }, // sky
  { background: "#f0fdf4", color: "#14532d" }, // mint
  { background: "#d1d5db", color: "#374151" },
];

export const getRandomIconColors = (name = "") => {

  // if name is available, deterministic per name, not random
  if(name){
    const index = (name?.charCodeAt(0) || 0) % ICON_BACKGROUNDS.length;
    return ICON_BACKGROUNDS[index];  // deterministic per name, not random
  }
  
  return ICON_BACKGROUNDS[Math.floor(Math.random() * ICON_BACKGROUNDS.length)];
};

const NOTIFICATION_ICONS = {
  booking:  { icon: "fa-bell",       gradient: "linear-gradient(135deg,#f093fb,#8b5cf6)", accent: "#8b5cf6" },
  review:   { icon: "fa-star",       gradient: "linear-gradient(135deg,#ffecd2,#f97316)", accent: "#f97316" },
  follower: { icon: "fa-user-plus",  gradient: "linear-gradient(135deg,#43e97b,#10b981)", accent: "#10b981" },
  payment:  { icon: "fa-credit-card",gradient: "linear-gradient(135deg,#4facfe,#00f2fe)", accent: "#0891b2" },
  //default:  { icon: "fa-bell",       gradient: "linear-gradient(135deg,#f093fb,#8b5cf6)", accent: "#8b5cf6" },
  //default:  { icon: "fa-info-circle",gradient: null,                               accent: null },
  //default: { icon: "fa-info-circle", gradient: "linear-gradient(135deg,#93c5fd,#3b82f6)", accent: "#3b82f6" },
  //default: { icon: "fa-info-circle", gradient: "linear-gradient(135deg,#4facfe,#0891b2)", accent: "#0891b2" },
  default: { icon: "fa-info-circle", gradient: "linear-gradient(135deg,#93c5fd,#3b82f6)", accent: "#3b82f6" },


};

export const getNotificationStyle = (type) => {
  return NOTIFICATION_ICONS[type] || NOTIFICATION_ICONS.default;
}


 const STATUS_CONFIG = {
        success: {
            icon: "fa-check",
            iconBg: "#dcfce7", iconBorder: "#86efac", iconColor: "#166534",
            headerBg: "#f0fdf4", headerBorder: "#bbf7d0", headerColor:"#16a34a",
            title: "Payment Successful",
            subtitle: "Your subscription is now active",
            titleColor: "#14532d", subtitleColor: "#166534",
            pillBg: "#dcfce7", pillColor: "#166534", pillLabel: "Active",
        },
        pending: {
            icon: "fa-clock-o",
            iconBg: "#fef9c3", iconBorder: "#fde047", iconColor: "#854d0e",
            headerBg: "#fefce8", headerBorder: "#fef08a",
            title: "Payment Pending",
            subtitle: "We are verifying your transaction",
            titleColor: "#713f12", subtitleColor: "#854d0e",
            pillBg: "#fef9c3", pillColor: "#854d0e", pillLabel: "Pending",
        },
        error: {
            icon: "fa-times",
            iconBg: "#fee2e2", iconBorder: "#fca5a5", iconColor: "#991b1b",
            headerBg: "#fef2f2", headerBorder: "#fecaca",
            title: "Payment Failed",
            subtitle: "Please try again later",
            titleColor: "#991b1b", subtitleColor: "#b91c1c",
            pillBg: "#fee2e2", pillColor: "#991b1b", pillLabel: "Failed",
        },
         default: {
            icon: "fa-clock-o",
            iconBg: "#fef9c3", iconBorder: "#fde047", iconColor: "#854d0e",
            headerBg: "#fefce8", headerBorder: "#fef08a",
            title: "Payment Pending",
            subtitle: "We are verifying your transaction",
            titleColor: "#713f12", subtitleColor: "#854d0e",
            pillBg: "#fef9c3", pillColor: "#854d0e", pillLabel: "Pending",
        }
    };

export const getTransactionStatusStyle = (key) => {
  return STATUS_CONFIG[key] || STATUS_CONFIG.default;
}